interface PaywallRibbonProps {
  discount: number;
}
export const PaywallRibbon: React.FC<PaywallRibbonProps> = (props: PaywallRibbonProps) => {
  return (
    <div className="absolute left-[-13px] top-[25px]">
      <svg width="128" height="111" viewBox="0 0 128 111" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask
          id="mask0_928_19588"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="12"
          y="16"
          width="12"
          height="95"
        >
          <path d="M23.8989 16.29H12.957V110.998H23.8989V16.29Z" fill="white" />
        </mask>
        <g mask="url(#mask0_928_19588)">
          <path
            opacity="0.8"
            d="M12.6406 103.671C17.2563 103.671 20.998 84.2031 20.998 60.1885C20.998 36.1738 17.2563 16.7061 12.6406 16.7061C8.02493 16.7061 4.2832 36.1738 4.2832 60.1885C4.2832 84.2031 8.02493 103.671 12.6406 103.671Z"
            fill="url(#paint0_radial_928_19588)"
          />
        </g>
        <path
          d="M0.000902346 68.0465C0.000902346 68.0465 -0.319145 79.1881 12.9608 79.1881V56.1045C12.9608 56.1045 -0.124974 57.8353 0.000902346 68.0465Z"
          fill="#9C1630"
        />
        <path
          d="M11.3066 0.0012421C5.0626 0.0012421 0 4.52248 0 10.0988V44.2343V58.8246V68.1579C1.67686 61.6631 7.10266 59.4733 11.7144 58.8246H128L108.563 31.1579L128 0L11.3066 0.0012421Z"
          fill="url(#paint1_linear_928_19588)"
        />
        <defs>
          <radialGradient
            id="paint0_radial_928_19588"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(12.6409 60.1869) scale(8.85056 40.8868)"
          >
            <stop stopColor="#8B8B8B" />
            <stop offset="0.0919" stopColor="#989898" />
            <stop offset="0.5148" stopColor="#CFCFCF" />
            <stop offset="0.83" stopColor="#F2F2F2" />
            <stop offset="1" stopColor="#F8FAFC" />
          </radialGradient>
          <linearGradient
            id="paint1_linear_928_19588"
            x1="64"
            y1="43.8158"
            x2="62.5779"
            y2="118.304"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF2C55" />
            <stop offset="1" stopColor="#9C1630" />
          </linearGradient>
        </defs>
      </svg>
      <div className="flex absolute font-semibold top-[-3px] left-[15px] tracking-tight-[1px] text-white items-center gap-[6px]">
        <div className="text-[43px] grow leading-[64px]">{props.discount}</div>
        <div className="flex flex-col grow-0 w-10 leading-[14px] text-xs justify-between shrink-0 h-[41px]">
          <span className="block text-[18px] leading-[20px]">%</span>
          <span className="block uppercase relative bottom-[2px]">Off</span>
        </div>
      </div>
    </div>
  );
};
